import React from 'react';
import css from './QuoteUpdate.module.css';
import QuoteCard from '../../../../../../v2/components/Dossier/EntityDossier/Body/Facets/QuoteCard/QuoteCard';

const QuoteUpdate = ({ update }) => {
  return (
    <div className={css.card}>
      <QuoteCard quote={update} showEvent="true" />
    </div>
  );
};

export default QuoteUpdate;
